import { render, staticRenderFns } from "./CUDataTableRowEditActions.vue?vue&type=template&id=2a4a3666"
import script from "./CUDataTableRowEditActions.vue?vue&type=script&lang=ts"
export * from "./CUDataTableRowEditActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports